import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/"
)({
  component: RouteComponent,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content",
      params,
      replace: true,
      statusCode: 307,
    });
  },
});

function RouteComponent() {
  return null;
}
